import React, { useEffect, useState } from 'react';
import { useScheduler } from '../../schedulerContext';

export const  SystemsTable = ({ systems = [] }) => {
    const { parameters, setParameters } = useScheduler();
  const [credentials, setCredentials] = useState({});
    
    const handleInputChange = (event, system, field) => {
        setCredentials(prevCredentials => ({
          ...prevCredentials,
          [system]: { ...prevCredentials[system], [field]: event.target.value }
        }));

        if(!parameters.system.length){
          setParameters(p => ({
              ...p,
              system: systems.map(s => 
                s === system ? { name: s, [field]: event.target.value } : { name: s, userId: '', password: '' }
              )
            }));
        }
        else{
          setParameters(p => {
              const updatedSystems = p.system ? p.system.map(s => 
                s.name === system ? { ...s, [field]: event.target.value } : s
              ) : [];
              return { ...p, system: updatedSystems };
            });
        }
        
      };
    
 

    useEffect(() => {
        if (!systems || !parameters.system) return;
            
          setCredentials(
            systems.reduce((acc, system) => {
              const found = parameters.system.find(s => s.name === system);
              acc[system] = { 
                userId: found?.userId || '', 
                password: found?.password || ''
              };
              return acc;
            }, {})
          );
    }, [systems, parameters.system]);

  

    



  return (
    <div style={{ maxWidth: "350px",width:"350px"}}>
      <table>
        <thead>
          <tr>
            <th style={{maxWidth:"120px",width:"120px"}}>System</th>
            <th style={{maxWidth:"120px",width:"120px"}}>User ID</th>
            <th style={{maxWidth:"120px",width:"120px"}}>Password</th>
          </tr>
        </thead>
        {
            (systems && systems.length) ? 
            <tbody>
            {systems.map(system => (
              <tr key={system}>
                <td>{system}</td>
                <td>
                  <input
                    type="text"
                    style={{width:"120px",outline:"none"}}
                    spellCheck={'false'}
                    value={credentials[system]?.userId || ""}
                    onChange={e => handleInputChange(e, system, 'userId')}
                  />
                </td>
                <td>
                  <input
                    type="password"
                    style={{width:"120px",outline:"none"}}
                    spellCheck={'false'}
                    value={credentials[system]?.password || ""}
                    onChange={e => handleInputChange(e, system, 'password')}
                  />
                </td>
              </tr>
            ))}
          </tbody> : <tbody>
            <tr>
              <td colSpan={3} style={{ textAlign: 'center' }}>
                No data available
              </td>``
            </tr>
          </tbody>
        }
        
      </table>
    </div>
  );
}


